import React from "react";

export const ScaleRow = ({ label, hint, min = 1, max = 5, value, onChange, ends, testid, reverse }) => {
  const nums = Array.from({ length: max - min + 1 }, (_, i) => min + i);
  const color = (n) => {
    const t = (n - min) / (max - min || 1);
    const good = reverse ? 1 - t : t;
    return good > 0.66 ? "#4ade80" : good > 0.33 ? "#facc15" : "#f87171";
  };
  return (
    <div style={{ marginBottom: 18 }} data-testid={testid}>
      <div style={{ fontWeight: 700, fontSize: 15 }}>{label}</div>
      {hint && <div style={{ fontSize: 12, color: "#a3a3a3", marginTop: 2 }}>{hint}</div>}
      <div style={{ display: "grid", gridTemplateColumns: `repeat(${nums.length}, 1fr)`, gap: 6, marginTop: 8 }}>
        {nums.map((n) => (
          <button key={n} type="button" onClick={() => onChange(n)} data-testid={`${testid}-${n}`}
            style={{ height: 46, fontSize: 16, fontWeight: 800, cursor: "pointer", border: `1px solid ${value === n ? color(n) : "rgba(255,255,255,0.12)"}`,
              background: value === n ? `${color(n)}22` : "rgba(255,255,255,0.03)", color: value === n ? color(n) : "#d4d4d4", transition: "background-color .15s, border-color .15s" }}>
            {n}
          </button>
        ))}
      </div>
      {ends && <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: "#737373", marginTop: 4 }}><span>{ends[0]}</span><span>{ends[1]}</span></div>}
    </div>
  );
};
